import { render, staticRenderFns } from "./totalOrderPopUpBox.vue?vue&type=template&id=54eaaec0&scoped=true"
import script from "./totalOrderPopUpBox.vue?vue&type=script&lang=js"
export * from "./totalOrderPopUpBox.vue?vue&type=script&lang=js"
import style0 from "./totalOrderPopUpBox.vue?vue&type=style&index=0&id=54eaaec0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eaaec0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54eaaec0')) {
      api.createRecord('54eaaec0', component.options)
    } else {
      api.reload('54eaaec0', component.options)
    }
    module.hot.accept("./totalOrderPopUpBox.vue?vue&type=template&id=54eaaec0&scoped=true", function () {
      api.rerender('54eaaec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/totalOrderPopUpBox.vue"
export default component.exports